// extracted by mini-css-extract-plugin
module.exports = {"container":"simpleModal_container__1FtJq","title":"simpleModal_title__3B3DF","content":"simpleModal_content__3MG9n","titleRed":"simpleModal_titleRed__2aEmQ"};